import { createContext } from 'react';

import createContextHelpers from 'utils/create-context-helpers';

const ColorsContext = createContext();
export const { ColorsProvider, useColors, withColors } = createContextHelpers(ColorsContext, 'colors');
